import { get } from 'lodash';

import { Location } from './location-data-store';

export const id = (location: Location) => get(location, 'id');

export const title = (location: Location) => get(location, 'title') || id(location);

export const translatedTitle = (location: Location) =>
    get(location, 'translatedTitle.translatedString.fr');

export const barCode = (location: Location) => {
    return get(location, 'locationCS.barCodes.translatedString.fr');
};

export const identifier = (location: Location) => {
    return get(
        location,
        'locationCS.barCodes.translatedString.fr',
        translatedTitle(location) || id(location),
    );
};
